import styles from "./business-profile.module.css";
import ProfileIcon from "../Icons/profile-icon";
import MailIcon from "../Icons/mail-icon";
import { activeCompanySelector } from "../../Reducers/activeCompanyReducer";
import { useSelector } from "react-redux";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";
import { plansSelector } from "../../Reducers/plansReducer";

const MapPickerIcon = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.0014 9.88836C10.416 9.88836 10.7704 9.74072 11.0648 9.44544C11.3592 9.15017 11.5064 8.79524 11.5064 8.38065C11.5064 7.96607 11.3588 7.61155 11.0635 7.31711C10.7682 7.0228 10.4132 6.87565 9.9985 6.87565C9.58392 6.87565 9.22948 7.02329 8.93517 7.31857C8.64073 7.61385 8.4935 7.96885 8.4935 8.38357C8.4935 8.79815 8.64114 9.1526 8.93642 9.4469C9.2317 9.74121 9.5867 9.88836 10.0014 9.88836ZM9.99996 16.2619C11.6302 14.8025 12.8778 13.4026 13.7427 12.0623C14.6075 10.722 15.04 9.54815 15.04 8.54065C15.04 7.02148 14.5573 5.7726 13.592 4.79399C12.6268 3.81537 11.4294 3.32607 9.99996 3.32607C8.57052 3.32607 7.37316 3.81537 6.40788 4.79399C5.4426 5.7726 4.95996 7.02148 4.95996 8.54065C4.95996 9.54815 5.39239 10.722 6.25725 12.0623C7.12211 13.4026 8.36968 14.8025 9.99996 16.2619ZM9.99996 17.9252C7.90274 16.108 6.3301 14.4168 5.28204 12.8517C4.23399 11.2864 3.70996 9.8494 3.70996 8.54065C3.70996 6.6176 4.33197 5.06072 5.576 3.87003C6.82017 2.67933 8.29482 2.08398 9.99996 2.08398C11.7051 2.08398 13.1798 2.67933 14.4239 3.87003C15.6679 5.06072 16.29 6.6176 16.29 8.54065C16.29 9.8494 15.7659 11.2864 14.7179 12.8517C13.6698 14.4168 12.0972 16.108 9.99996 17.9252Z" fill="#525252"/>
    </svg>)
}

const GreenCheckIcon = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.34307 18.2214L5.85599 15.7151L3.03224 15.0964L3.30786 12.1895L1.39453 10.0003L3.30786 7.81117L3.03224 4.9043L5.85599 4.28555L7.34307 1.7793L10.0002 2.90742L12.6572 1.7793L14.1443 4.28555L16.9681 4.9043L16.6924 7.81117L18.6058 10.0003L16.6924 12.1895L16.9681 15.0964L14.1443 15.7151L12.6572 18.2214L10.0002 17.0933L7.34307 18.2214ZM9.12516 12.6701L13.5449 8.25034L12.6668 7.34659L9.12516 10.8883L7.33349 9.12221L6.45537 10.0003L9.12516 12.6701Z" fill="#008062"/>
    </svg>)
}

export const CompanyInfoCard = () => {
    const activeCompanyId = useSelector(activeCompanySelector);
    const { data: companies } = useFetchCompanyInfosQuery();
    const plans = useSelector(plansSelector);

    const company = companies?.getAccountDetailsByCompanyId(activeCompanyId);

    if (!company) return null;

    return (
        <div className={styles.side}>
            <div className={styles.sideCard}>
                <div className={styles.companyInfo}>
                    <div className={styles.companyInfoHeader}>
                        {company.imagePath && <img className={styles.companyLogo} src={company.imagePath} alt="Company Logo" />}
                        {/* <div className={styles.statusBadge}>Active</div> */}
                    </div>
                    <div className={styles.companyInfoMain}>
                        <div className={styles.companyTitle}>{company.companyName}</div>
                        <div className={styles.companyCountryRow}>
                            <MapPickerIcon />
                            <div className={styles.companyCountry}>{company.country}</div>
                        </div>
                    </div>
                    {/* <div className={styles.companyDesc}>Heavy delivery volume. Admin responds promptly.</div> */}
                </div>

                {/* <div className={styles.statusBadges}>
                    <div className={styles.statusBadge}>Premium plan</div>
                    <div className={styles.statusBadge}>SMS enabled</div>
                    <div className={styles.statusBadge}>Multi–location</div>
                    <div className={styles.statusBadge}>High usage</div>
                </div> */}

                <div className={styles.adminSection}>
                    <div className={styles.adminLabel}>Admin</div>
                    <div className={styles.adminCard}>
                        <div className={styles.adminRow}>
                            <ProfileIcon dimension={20} />
                            <div className={styles.adminName}>{company.adminName}</div>
                        </div>
                        <div className={styles.adminRow}>
                            <MailIcon dimension={20} />
                            <div className={styles.adminEmail}>{company.email}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.divider80} />

                <div className={styles.feature}>
                    {plans.isPaid(company.currentPlan) && <GreenCheckIcon />}
                    <div className={styles.featureText}>{plans.getDisplayName(company.currentPlan)}</div>
                </div>
            </div>
        </div>
    )
}
